const algoliasearch = require('algoliasearch');

module.exports = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_INDEX_API_KEY
);
